<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { setRoutes } from "@/router";

export default {
  name: 'App',
  mounted() {
    // 在组件创建时检查
    const userStr = localStorage.getItem('login');
    if (userStr) {
      const user = JSON.parse(userStr);

      // 重新从后端获取最新菜单，确保数据一致性，防止本地篡改
      this.request.post("/user/login", user).then((res) => {
        if (res.code === '200') {
          localStorage.setItem('menus', JSON.stringify(res.data.menus));
          console.log('重新获取的菜单：', res.data);
          // 动态设置路由
          setRoutes();
          
          // // 注意：如果当前页面需要刷新路由才能生效，可能需要强制刷新或重定向
          // // 例如：如果当前在登录页，可能需要跳转到首页
          // if (this.$route.path === '/login') {
          //    this.$router.push('/home');
          // }
        }
      }).catch(err => {
        console.error("获取菜单失败", err);
        // 可选：如果获取失败，可能是token过期，可以清除本地存储并跳转登录
        localStorage.clear();
        this.$router.push('/login');
      });
    }
  }
}
</script>

<style>
.el-menu {
  min-height: 100%; 
  overflow-x: hidden;
}
</style>